// extracted by css-extract-rspack-plugin
var _1 = "HeaderWarningBanner-m_banner-K3bobeFg common-m_flexRow-ZPndn63a";
export { _1 as "banner" }
